var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm2 0c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Zm-7.862-4.067a1 1 0 0 0-1.414 0l-2.688 2.688-2.688-2.688a1 1 0 1 0-1.414 1.414l2.688 2.688-2.686 2.686a1 1 0 1 0 1.414 1.414l2.686-2.686 2.686 2.686a1 1 0 1 0 1.414-1.414l-2.686-2.686 2.688-2.688a1 1 0 0 0 0-1.414Z",
    fill: "#CACAD8"
  })));
};
export default SvgCross;